"use client";
import {useEffect} from "react";
import {Button} from "@/app/_components";
import styles from "./Step3_4_5.module.css";
import GameTrack from "@/Core/GameTrack";

type Step5Props = {
    target?: () => HTMLElement | null;
    currentStep?: number;
    currIndex?: number;
    onNext?: (idx: number) => void;
    onClose?: () => void;
}

const buttonStyle: React.CSSProperties = {
    color: "#fff",
    width: "3.7rem",
    height: "1.1rem",
    fontWeight: 900,
    fontSize: ".5rem"
}

const Step5: React.FC<Step5Props> = props => {
    const { target, currentStep, currIndex, onClose } = props;

    const _targetStyle = target?.()?.getBoundingClientRect();
    if (!_targetStyle) return;

    const { x, width, } = _targetStyle;
    const wrapperStyle: React.CSSProperties = {
        position: 'absolute',
        width: width,
        height: '1.95rem',
        bottom: 0,
        left: x,
    }

    useEffect(() => {
        return () => {
        };
    }, [])

    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // e.stopPropagation();
        // if (currentStep === currIndex) {
        //     onClose && onClose()
        // }
    }

    return (
        <>
            {(currentStep === currIndex) && <div style={wrapperStyle}>
                <div className={styles.step3}>
                    <img src="/img/guide/Account.webp" style={{width: width > 129 ? 129 : width}} alt=""/>
                    <div className={styles.arrow}></div>
                    <div className={`${styles.popover} ${styles.popover_step4}`}>
                        Viewing and modifying your information.
                        <div className={`${styles.button} ${styles.button_step4}`}>
                            <Button color="#0090FF" style={buttonStyle} onClick={handleClick}>Okay</Button>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default Step5;